module.exports = __webpack_public_path__ + "img/waatca_nft_logo.87954996.png";